import { Formik } from "formik";
import React, { useState, useEffect, useContext, useRef } from "react";
import "./styles.css";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { FiChevronLeft, FiChevronRight, FiShoppingBag } from "react-icons/fi";
import {
  LuShieldCheck,
  LuTriangleAlert,
  LuAward,
  LuPill,
  LuSparkles,
  LuPackage,
} from "react-icons/lu";
import { LocalShipping, Speed } from "@material-ui/icons";
import api from "../../services/api";
import CardSale from "../../components/CardSale";
import { Creators as ProductsActions } from "../../store/ducks/products";
import { Creators as CartActions } from "../../store/ducks/cart";
import Loader from "react-loader-spinner";
import CartaoVantagens from "../../assets/images/cartao-vantagens.png";
import HelmetCustom from "../../components/HelmetCustom";
import JsonLd from "../../components/JsonLd";
import Breadcrumb from "../../components/Breadcrumb";
import Link from "../../components/Link";
import ModalConfirm from "../../components/ModalConfirm";
import ModalLayout from "../../components/ModalLayout";
import { NotificationSchema } from "./validation";

import {
  Container,
  Form,
  FormGroup,
  Label,
  InputField,
  FieldErrorMessage,
  SubmitButton,
  LoaderContainer,
  ProductShop,
  ContainerName,
  TextOldValue,
  TextNewValue,
  ContainerAdvantageCard,
  ContainerNewValue,
  InstallmentText,
  InstallmentHint,
  ContainerSpecialPricesList,
  ContainerProduct,
  ContainerPromo,
  ContainerWithoutStock,
  AddToCartButton,
  StyledButtonSecondary,
  ContainerGalleryImages,
  GalleryImagesStyled,
  BadgeNew,
  PrinciplesRow,
  PrincipleBadge,
  AttrText,
  RatingPlaceholder,
  Highlights,
  Divider,
  PriceBlock,
  ActionRow,
  FavoriteButton,
  RegulatoryAlert,
  TrustBadgesRow,
  TrustBadge,
  TechnicalSheet,
  SheetColumn,
  SheetTitle,
  SheetSubtitle,
  DescriptionHtml,
  LegalBoxGray,
  LegalBoxRed,
  AttributesTable,
  ActivePrinciplesTable,
  RelatedSection,
  RelatedViewport,
  RelatedTrack,
  RelatedArrow,
  ManufacturerText,
  NotFoundContainer,
  PixHint,
} from "./styles";

import { formatPrice } from "../../util/format";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import IncrementItem from "../../components/IncrementItem";
import CardSpecialPriceProduct from "../../components/CardSpecialPriceProduct";
import MainLayout from "../../components/MainLayout";
import { StripeType } from "../../util/stripeType";
import { allowBuy } from "../../util/buy";
import DeliveryCard from "../../components/DeliveryCard";
import { composeDeliveryEstimate, getStockForStore, StockOrigin } from "../../util/deliveryEstimate";
import { Status, selectDescontoPixDoContexto } from "../../store/ducks/deliveryContext";
import PixDiscountBadge from "../../components/PixDiscountBadge";
import { precoNoPix } from "../../util/pixPrice";
import GalleryImages from "../../components/GalleryImages";
import { ThemeContext } from "styled-components";
import { getIdealInfoPrice, temPrecoDeVenda } from "../../util/price";
import { resolverAlertaRegulatorio } from "../../util/alertaRegulatorio";
import { OrdenationContext } from "../../contexts/OrdenationContext";
import { getCanonicalOrigin } from "../../util/domain";
import {
  AreaAplicacaoLabels,
  UnidadeEmbalagemLabels,
  UnidadeConteudoLabels,
  UnidadeEmbalagemLabelsPlural,
  UnidadeConteudoLabelsPlural,
  ApresentacaoLabels,
  ViaAdministracaoLabels,
  TamanhoLabels,
  TipoMedicamentoLabels,
  ClasseTerapeuticaLabels,
  TipoMedicamento,
  resolveEnumLabel,
  resolveUnitLabel,
} from "../../util/productEnums";

function toPlainText(html) {
  if (!html) return "";
  return String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function prescriptionSuffix(tipoMedicamento) {
  switch (tipoMedicamento) {
    case TipoMedicamento.GENERICO:
      return "MEDICAMENTO GENÉRICO – LEI N.º 9.787/99.";
    case TipoMedicamento.SIMILAR:
      return "MEDICAMENTO SIMILAR.";
    case TipoMedicamento.REFERENCIA:
      return "MEDICAMENTO DE REFERÊNCIA.";
    default:
      return "";
  }
}

function buildCharacteristics(product) {
  const tarjaMap = { V: "Vermelha", P: "Preta", N: "Sem tarja" };
  const hasTarja = !!product.tarja && product.tarja !== StripeType.nothing;
  const unidadeEmbalagem = resolveUnitLabel(
    UnidadeEmbalagemLabels, UnidadeEmbalagemLabelsPlural,
    product.unidade_embalagem, product.quantidade_embalagem
  );
  const unidadeConteudo = resolveUnitLabel(
    UnidadeConteudoLabels, UnidadeConteudoLabelsPlural,
    product.unidade_conteudo, product.quantidade_conteudo
  );
  const embalagem = [product.quantidade_embalagem, unidadeEmbalagem].filter(Boolean).join(" ");
  const conteudo = [product.quantidade_conteudo, unidadeConteudo].filter(Boolean).join(" ");

  const rows = [
    ["Ref.", product.id],
    ["SKU", product.codigo_interno],
    ["Código de barras", product.ean],
    ["Fabricante", product.fabricante],
    ["Registro Anvisa", product.numero_registro_anvisa],
    ["Apresentação", resolveEnumLabel(ApresentacaoLabels, product.apresentacao)],
    ["Embalagem", embalagem || null],
    ["Conteúdo", conteudo || null],
    ["Dosagem", product.dosagem],
    ["Via de administração", resolveEnumLabel(ViaAdministracaoLabels, product.via_administracao)],
    ["Tarja", hasTarja ? tarjaMap[product.tarja] || null : null],
    [
      "Retém receita",
      hasTarja && typeof product.retem_receita === "boolean"
        ? product.retem_receita
          ? "Sim"
          : "Não"
        : null,
    ],
    ["Tipo de medicamento", resolveEnumLabel(TipoMedicamentoLabels, product.tipo_medicamento)],
    ["Classe terapêutica", resolveEnumLabel(ClasseTerapeuticaLabels, product.classe_terapeutica)],
    ["Faixa etária", product.faixa_etaria],
    ["Tamanho", resolveEnumLabel(TamanhoLabels, product.tamanho)],
    ["Sabor", product.sabor],
    ["Área de aplicação", resolveEnumLabel(AreaAplicacaoLabels, product.area_aplicacao)],
    ["FPS", product.fps],
    ["Peso", product.peso != null && product.peso !== "" ? `${product.peso}g` : null],
    ["É kit", typeof product.kit === "boolean" ? (product.kit ? "Sim" : "Não") : null],
  ];

  return rows.filter(([, value]) => value !== null && value !== undefined && value !== "");
}

export default function ProductDetail({ history, match }) {
  const dispatch = useDispatch();
  const { selected: product, searchLoading, message, requestedNotifyProducts } = useSelector(
    state => state.products
  );
  const store = useSelector(state => state.storeByUser.data);
  const selectedStoreUuid = store?.uuid;
  const selectedProductId = product?.id;
  const { data } = useSelector(state => state.store);
  const user = useSelector((state) => state.user.profile);
  const { loading: loadingItemInCart } = useSelector(state => state.cart);
  const { status: deliveryStatus, conflitoFarmacia, resolucao } = useSelector(
    (state) => state.deliveryContext
  );
  const descontoPix = useSelector(selectDescontoPixDoContexto, shallowEqual);
  const [quantity, setQuantity] = useState(1);
  const [isFavorite, setIsFavorite] = useState(false);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const relatedTrackRef = useRef(null);
  const theme = useContext(ThemeContext);
  const { ordenation } = useContext(OrdenationContext);
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [showModalMessage, setShowModalMessage] = useState(false);
  const [showModalNotification, setShowModalNotification] = useState(false);
  const { programa_fidelidade = false } = useSelector((state) =>
    state.user.profile == null ? false : state.user.profile
  );
  const origin = getCanonicalOrigin(data?.empresa?.url_canonica, window.location.origin);

  useEffect(() => {
    dispatch(ProductsActions.showProductRequest(match.params.slug));
  }, [dispatch, match.params.slug, selectedStoreUuid]);

  useEffect(() => {
    if (selectedProductId) {
      dispatch(ProductsActions.getProductNotifyStock({ productId: selectedProductId, user }));
    }
  }, [dispatch, selectedProductId, user]);

  useEffect(() => {
    setShowModalMessage(message !== "");
    setShowModalAlert(false);
  }, [message])

  useEffect(() => {
    if (product?.id) {
      setIsFavorite(sessionStorage.getItem(`favorito_${product.id}`) === "1");
    }
  }, [product?.id]);

  useEffect(() => {
    let active = true;

    async function fetchRelated() {
      const subCategoryId = product?.subcategoria?.id;
      const categoryId = product?.categoria?.id;

      if (!product?.id || (!subCategoryId && !categoryId)) {
        setRelatedProducts([]);
        return;
      }

      const filterParam = subCategoryId
        ? `_subCategory=${subCategoryId}`
        : `_category=${categoryId}`;

      try {
        const { data } = await api.get(
          `products?${filterParam}&_offset=0&_limit=12${store !== null ? `&store=${store.uuid}` : ""}`
        );
        if (active) {
          setRelatedProducts((data || []).filter(item => item.id !== product.id).slice(0, 10));
        }
      } catch (err) {
        if (active) setRelatedProducts([]);
      }
    }

    fetchRelated();

    return () => {
      active = false;
    };
  }, [product?.id, product?.subcategoria?.id, product?.categoria?.id, store]);

  function scrollRelated(direction) {
    if (relatedTrackRef.current) {
      relatedTrackRef.current.scrollBy({ left: direction * 294, behavior: "smooth" });
    }
  }

  function addProductToCart() {
    if (quantity > 0) {
      dispatch(CartActions.addProduct(product, parseInt(quantity)));
      const newQuantity = product.quantidade + quantity;

      dispatch(
        ProductsActions.setSelectedProduct({
          ...product,
          quantidade: newQuantity
        })
      );
      setQuantity(1);
    }
  }

  function toggleFavorite() {
    if (!product?.id) return;
    const next = !isFavorite;
    setIsFavorite(next);
    const key = `favorito_${product.id}`;
    if (next) {
      sessionStorage.setItem(key, "1");
    } else {
      sessionStorage.removeItem(key);
    }
  }

  function addNotificationAvailable() {
    if (user) {
      dispatch(ProductsActions.addProductNotifyStock({ productId: product.id, user }));
    } else {
      setShowModalNotification(true);
    }
  }

  function removeNotification() {
    dispatch(ProductsActions.removeProductNotifyStock({ productId: product.id, user }));
  }

  function handleSubmit({ nome, email }) {
    setShowModalNotification(false);
    dispatch(ProductsActions.addProductNotifyStock({ productId: product.id, nome, email }));
  }

  function closeMessage() {
    dispatch(ProductsActions.clearMessage({}));
    setShowModalMessage(false);
  }

  if (searchLoading) {
    return (
      <LoaderContainer>
        <Loader type="Oval" color={theme.colors.primary} height={40} width={40} />
      </LoaderContainer>
    );
  }

  if (!product || !product.id) {
    return (
      <MainLayout history={history}>
        <NotFoundContainer>
          <h2>Produto não encontrado</h2>
          <p>
            O produto que você procura não está mais disponível ou o endereço está
            incorreto.
          </p>
          <Link text="Voltar para a página inicial" action={() => history.push("/")} />
        </NotFoundContainer>
      </MainLayout>
    );
  }

  const { priceOf, priceBy, hasFacilityProgramInPriceBy, discount, alternativePrices } = getIdealInfoPrice(product.precos, programa_fidelidade);

  const maxInstallments = Number(data?.empresa?.limite_parcelamento) || 0;
  const minimumOrderValue = Number(data?.empresa?.valor_minimo_parcelamento) || 0;
  const minimumInstallmentValue = Number(data?.empresa?.valor_minimo_parcela) || 0;
  const maxInstallmentsByValue = minimumInstallmentValue > 0
    ? Math.floor(Number(priceBy) / minimumInstallmentValue)
    : maxInstallments;
  const availableInstallments = Math.min(maxInstallments, maxInstallmentsByValue);
  const canInstallment =
    availableInstallments > 1 && Number(priceBy) >= minimumOrderValue;
  const installmentBelowMinimum =
    maxInstallments > 1 && !canInstallment && minimumOrderValue > 0;

  // Preço no Pix da farmácia do contexto em destaque; sem farmácia conhecida, "até X% OFF no Pix" (P-113).
  // Sem estoque na farmácia do contexto não há Pix (spec desconto-pix-vitrine 3.5, P-117)
  const semEstoqueNaFarmaciaPix =
    descontoPix.conhecida &&
    getStockForStore(product, descontoPix.lojaId).origem === StockOrigin.NENHUM;
  const pixPrice =
    descontoPix.conhecida && !semEstoqueNaFarmaciaPix
      ? precoNoPix(priceBy, descontoPix.perc)
      : null;
  const pixAte = !descontoPix.conhecida && descontoPix.percMax > 0;
  const installmentLabel = canInstallment
    ? `em até ${availableInstallments}x sem juros no cartão`
    : "à vista no cartão";

  // Prazo e custo a partir do contexto de entrega. A API devolve os tempos separados e ja
  // elegeu a modalidade; a composicao depende da origem do estoque, que so o front conhece.
  const lojaEntrega = resolucao?.entrega?.lojas?.find(
    (loja) => loja.loja_id === resolucao.entrega.eleita_loja_id
  );
  const lojaRetirada = resolucao?.retirada?.lojas?.find(
    (loja) => loja.loja_id === resolucao.retirada.eleita_loja_id
  );
  const deliveryEstimate =
    deliveryStatus === Status.ATENDIDO && !conflitoFarmacia
      ? composeDeliveryEstimate({ product, lojaEntrega, lojaRetirada })
      : null;

  // O chip de logistica so existe quando ha prazo real. Mante-lo fixo faria a mesma tela
  // exibir duas promessas contraditorias, e ele fica suprimido sem cobertura, em falha,
  // sem CEP, em conflito e sem estoque na farmacia que atende.
  const prazoParaChip = deliveryEstimate?.entregaExpressa
    ? { texto: deliveryEstimate.entregaExpressa.texto, icone: Speed }
    : deliveryEstimate?.entregaNormal
      ? { texto: deliveryEstimate.entregaNormal.texto, icone: LocalShipping }
      : null;

  const hasStock = (store !== null && product.estoque_loja > 0) || product.estoque_total > 0;
  // sem preço de venda (> 0) o produto aparece indisponível e não vai para a cesta
  const comPreco = temPrecoDeVenda(product.precos);
  const canBuy = allowBuy(store !== null, product.estoque_total, product.estoque_loja) && comPreco;
  const alertaRegulatorio = resolverAlertaRegulatorio(product);
  const plainDescription = toPlainText(product.descricao);
  const seoTitle = product.titulo_seo || product.nome;
  const seoDescription = product.meta_description || plainDescription || product.nome;
  const characteristics = buildCharacteristics(product);
  const activePrinciples = product.principios_ativos || [];
  const principleNames = activePrinciples.map(p => p.nome).filter(Boolean);
  const seoKeywords = Array.from(
    new Set([product.nome, ...(product.tags || []), ...principleNames].filter(Boolean))
  );

  function renderGalleryBadge() {
    if (product.estoque_total > 0 && discount > 0) {
      return (
        <ContainerPromo>
          <span>
            -{parseFloat(discount).toString().replace(".", ",")}%
          </span>
        </ContainerPromo>
      );
    }
    if (product.lancamento) {
      return (
        <BadgeNew>
          <span>Novo</span>
        </BadgeNew>
      );
    }
    return null;
  }

  function renderPrinciplesAndAttributes() {
    const attributes = [];
    const unidadeEmbalagem = resolveUnitLabel(
      UnidadeEmbalagemLabels, UnidadeEmbalagemLabelsPlural,
      product.unidade_embalagem, product.quantidade_embalagem
    );
    const viaAdministracao = resolveEnumLabel(ViaAdministracaoLabels, product.via_administracao);
    const embalagem = [product.quantidade_embalagem, unidadeEmbalagem].filter(Boolean).join(" ");
    if (embalagem) attributes.push(embalagem);
    if (viaAdministracao) attributes.push(viaAdministracao);

    if (!activePrinciples.length && !attributes.length) return null;

    return (
      <PrinciplesRow>
        {activePrinciples.map((principle, index) => (
          <PrincipleBadge key={principle.id || index}>{principle.nome}</PrincipleBadge>
        ))}
        {attributes.length > 0 && (
          <AttrText>
            {activePrinciples.length ? "· " : ""}
            {attributes.join(" · ")}
          </AttrText>
        )}
      </PrinciplesRow>
    );
  }

  function renderTrustBadges() {
    const badges = [
      { icon: LuShieldCheck, label: "Compra segura" },
    ];

    // Alimentado pelo prazo real da farmacia que atende o CEP, e ausente quando nao ha prazo.
    if (prazoParaChip) {
      badges.unshift({
        icon: prazoParaChip.icone,
        label: `Receba ${prazoParaChip.texto}`,
        materialIcon: true
      });
    }

    if (product.retem_receita) {
      badges.push({ icon: LuTriangleAlert, label: "Receita obrigatória", variant: "warning" });
    }
    if (product.tipo_medicamento === TipoMedicamento.REFERENCIA || product.tipo_medicamento === TipoMedicamento.SIMILAR) {
      badges.push({ icon: LuAward, label: "Original" });
    }
    if (product.tipo_medicamento === TipoMedicamento.GENERICO) {
      badges.push({ icon: LuPill, label: "Genérico" });
    }
    if (product.lancamento) {
      badges.push({ icon: LuSparkles, label: "Lançamento" });
    }
    if (product.kit) {
      badges.push({ icon: LuPackage, label: "Kit" });
    }

    return (
      <TrustBadgesRow>
        {badges.map((badge, index) => {
          const Icon = badge.icon;
          return (
            <TrustBadge key={index} variant={badge.variant}>
              {badge.materialIcon
                ? <Icon style={{ fontSize: "16px" }} />
                : <Icon size={16} />}
              {badge.label}
            </TrustBadge>
          );
        })}
      </TrustBadgesRow>
    );
  }

  return (
    <MainLayout history={history}>
      {product && (
        <>
          <HelmetCustom
            pageTitle={seoTitle}
            canonical={`${origin}/produtos/visualizar/${product?.url}`}
            fbUrl={`${origin}/produtos/visualizar/${product?.url}`}
            fbDescription={seoDescription}
            fbImage={product?.imagens?.[0]?.caminho_imagem}
            content={seoDescription}
            ogType="product"
            keywords={seoKeywords}
          />
          <JsonLd
            type="Product"
            data={{
              nome: product?.nome,
              descricao: seoDescription,
              imagem: product?.imagens?.[0]?.caminho_imagem,
              preco: priceBy || priceOf,
              precoOriginal: priceOf,
              disponivel: (product?.estoque_total || 0) > 0,
              url: `${origin}/produtos/visualizar/${product?.url}`,
              marca: product?.fabricante || '',
              keywords: seoKeywords,
              principiosAtivos: principleNames,
            }}
          />
        </>
      )}
      <Container>

        <ContainerProduct>
          <div className="route-detail">
            <Breadcrumb
              items={[
                ...(product?.categoria?.descricao
                  ? [{
                    name: product.categoria.descricao,
                    to: `/produtos/categoria/${encodeURIComponent(product.categoria.descricao.toLowerCase())}/${product.categoria.id}${ordenation ? `?ordering=${ordenation}` : ''}`,
                  }]
                  : []),
                ...(product?.subcategoria?.descricao
                  ? [{
                    name: product.subcategoria.descricao,
                    to: `/produtos/subcategoria/${encodeURIComponent(product.subcategoria.descricao.toLowerCase())}/${product.subcategoria.id}${ordenation ? `?ordering=${ordenation}` : ''}`,
                  }]
                  : []),
                { name: product.nome },
              ]}
            />
          </div>
          <div className="detail-container">
            <ContainerGalleryImages>
              <GalleryImages product={product} productName={product.nome} images={product.imagens}>
                {renderGalleryBadge()}
              </GalleryImages>
            </ContainerGalleryImages>

            <ProductShop>
              <GalleryImagesStyled product={product} productName={product.nome} images={product.imagens}>
                {renderGalleryBadge()}
              </GalleryImagesStyled>

              {product.fabricante && (
                <ManufacturerText>{product.fabricante}</ManufacturerText>
              )}

              <ContainerName>
                <h1>{product.nome}</h1>
              </ContainerName>

              {renderPrinciplesAndAttributes()}

              <RatingPlaceholder>Seja o primeiro a avaliar</RatingPlaceholder>

              {product.resumo_descricao && (
                <Highlights>{product.resumo_descricao}</Highlights>
              )}

              <Divider />

              {hasStock ? (
                <>
                  {comPreco ? (
                  <PriceBlock>
                    {priceOf !== priceBy && (
                      <TextOldValue>de {formatPrice(priceOf)}</TextOldValue>
                    )}
                    <ContainerNewValue>
                      <span>R$</span>
                      <TextNewValue>{Number(pixPrice ?? priceBy).toFixed(2).replace(".", ",")}</TextNewValue>
                      {pixPrice !== null && (
                        <PixHint>
                          <PixDiscountBadge perc={descontoPix.perc} />
                        </PixHint>
                      )}
                      {hasFacilityProgramInPriceBy && (
                        <ContainerAdvantageCard>
                          <img
                            className="programa-fidelidade"
                            alt="Programa fidelidade"
                            src={CartaoVantagens}
                          />
                        </ContainerAdvantageCard>
                      )}
                    </ContainerNewValue>
                    {pixAte && (
                      <PixDiscountBadge perc={descontoPix.percMax} ate small />
                    )}
                    <InstallmentText>
                      {pixPrice !== null
                        ? `ou ${formatPrice(priceBy)} ${installmentLabel}`
                        : installmentLabel.charAt(0).toUpperCase() + installmentLabel.slice(1)}
                    </InstallmentText>
                    {installmentBelowMinimum && (
                      <InstallmentHint>
                        Parcele em compras acima de {formatPrice(minimumOrderValue)}
                      </InstallmentHint>
                    )}
                    {alternativePrices && alternativePrices.length > 0 && (
                      <ContainerSpecialPricesList>
                        {alternativePrices.map(price => (
                          <CardSpecialPriceProduct key={price.priceId || `${price.type}-${price.takeQuantity || price.minimunQuantity || price.multipleQuantity}`} price={price} />
                        ))}
                      </ContainerSpecialPricesList>
                    )}
                  </PriceBlock>
                  ) : (
                    <ContainerWithoutStock>
                      <span>Produto indisponível no momento</span>
                    </ContainerWithoutStock>
                  )}

                  {canBuy && (
                    <>
                      <Divider />
                      <ActionRow>
                        {loadingItemInCart ? (
                          <Loader type="ThreeDots" color={theme.colors.primary} height={40} width={40} />
                        ) : (
                          <IncrementItem quantity={quantity} setQuantity={setQuantity} />
                        )}
                        <AddToCartButton
                          type="button"
                          disabled={loadingItemInCart}
                          onClick={addProductToCart}
                        >
                          <FiShoppingBag />
                          Adicionar à cesta
                        </AddToCartButton>
                        <FavoriteButton
                          type="button"
                          active={isFavorite}
                          onClick={toggleFavorite}
                          aria-label="Favoritar produto"
                        >
                          {isFavorite ? <AiFillHeart size={22} /> : <AiOutlineHeart size={22} />}
                        </FavoriteButton>
                      </ActionRow>
                    </>
                  )}

                  {alertaRegulatorio && (
                    <RegulatoryAlert>
                      <LuTriangleAlert size={20} />
                      <p>{alertaRegulatorio}</p>
                    </RegulatoryAlert>
                  )}

                  {renderTrustBadges()}

                  <Divider />
                  <DeliveryCard estimativa={deliveryEstimate} />
                </>
              ) : product.tarja !== StripeType.red && product.tarja !== StripeType.black ? (
                <ContainerWithoutStock>
                  <span>Sem estoque :(</span>
                  <br />
                  <>
                    {requestedNotifyProducts !== null && requestedNotifyProducts.situacao === 'P' && (
                      <>
                        <span>Você será informado quando o produto estiver disponível</span>
                        <StyledButtonSecondary text="Não me avisar mais" onClick={() => setShowModalAlert(true)} />
                        <ModalConfirm
                          message={"Você tem certeza que não quer ser mais notificado?"}
                          visible={showModalAlert}
                          textBtnConfirm="Sim"
                          textBtnCancel="Não"
                          confirm={() => {
                            removeNotification();
                          }}
                          cancel={() => {
                            setShowModalAlert(false);
                          }}
                        />
                      </>
                    )}
                    {(requestedNotifyProducts === null || requestedNotifyProducts.situacao !== 'P') && (
                      <>
                        <StyledButtonSecondary text="Avise-me quando estiver disponível" onClick={addNotificationAvailable} />
                      </>
                    )}
                    {showModalMessage && (
                      <>
                        <ModalConfirm
                          message={message}
                          visible={showModalMessage}
                          textBtnCancel="Ok"
                          cancel={closeMessage}
                        />
                      </>
                    )}
                    {showModalNotification && (
                      <>
                        <ModalLayout
                          showModal={true}
                          title={"Avise-me quando disponível"}
                          handleCloseModal={() => setShowModalNotification(false)}
                        >
                          <Formik
                            initialValues={{
                              nome: '',
                              email: '',
                            }}
                            validationSchema={NotificationSchema}
                            onSubmit={handleSubmit}
                          >
                            {({
                              values,
                              handleChange,
                              handleBlur,
                              errors,
                              touched,
                              handleSubmit,
                              isSubmitting
                            }) => (
                              <Form onSubmit={handleSubmit}>
                                <FormGroup>
                                  <Label>Nome Completo*</Label>
                                  {errors.nome && touched.nome ? (
                                    <FieldErrorMessage>{errors.nome}</FieldErrorMessage>
                                  ) : null}
                                  <InputField
                                    invalid={errors.nome && touched.nome}
                                    id="nome"
                                    type="text"
                                    name="nome"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.nome}
                                    placeholder="Ex: Fulano da Silva"
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <Label>E-mail*</Label>
                                  {errors.email && touched.email ? (
                                    <FieldErrorMessage>{errors.email}</FieldErrorMessage>
                                  ) : null}
                                  <InputField
                                    invalid={errors.email && touched.email}
                                    id="email"
                                    type="email"
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                    placeholder="Ex: fulano@gmail.com"
                                  />
                                </FormGroup>
                                <SubmitButton type="submit" disabled={false}>
                                  Cadastrar Aviso
                                </SubmitButton>
                              </Form>
                            )}
                          </Formik>
                        </ModalLayout>
                      </>
                    )}
                  </>
                </ContainerWithoutStock>
              ) : null}
            </ProductShop>

          </div>

          <TechnicalSheet>
            <SheetColumn>
              <SheetTitle>Descrição</SheetTitle>
              {product.descricao && (
                <DescriptionHtml dangerouslySetInnerHTML={{ __html: product.descricao }} />
              )}
              {product.retem_receita && (
                <LegalBoxGray>
                  VENDA SOB PRESCRIÇÃO MÉDICA. {prescriptionSuffix(product.tipo_medicamento)}
                </LegalBoxGray>
              )}
              {product.tarja === "P" && (
                <LegalBoxRed>
                  VENDA SOB PRESCRIÇÃO MÉDICA COM RETENÇÃO DE RECEITA. MEDICAMENTO SUJEITO A CONTROLE ESPECIAL.
                </LegalBoxRed>
              )}
            </SheetColumn>

            <SheetColumn>
              <SheetTitle>Características</SheetTitle>
              {characteristics.length > 0 && (
                <AttributesTable>
                  <tbody>
                    {characteristics.map(([label, value]) => (
                      <tr key={label}>
                        <td>{label}</td>
                        <td>{value}</td>
                      </tr>
                    ))}
                  </tbody>
                </AttributesTable>
              )}

              {activePrinciples.length > 0 && (
                <>
                  <Divider />
                  <SheetSubtitle>Princípios ativos</SheetSubtitle>
                  <ActivePrinciplesTable>
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Concentração</th>
                        <th>Unidade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activePrinciples.map((principle, index) => (
                        <tr key={principle.id || index}>
                          <td>{principle.nome}</td>
                          <td>{principle.concentracao}</td>
                          <td>{principle.unidade_medida}</td>
                        </tr>
                      ))}
                    </tbody>
                  </ActivePrinciplesTable>
                </>
              )}
            </SheetColumn>
          </TechnicalSheet>

          {relatedProducts.length > 0 && (
            <RelatedSection>
              <h2>Você também pode gostar</h2>
              <RelatedViewport>
                <RelatedArrow
                  type="button"
                  className="left"
                  aria-label="Anterior"
                  onClick={() => scrollRelated(-1)}
                >
                  <FiChevronLeft />
                </RelatedArrow>
                <RelatedTrack ref={relatedTrackRef}>
                  {relatedProducts.map(relatedProduct => (
                    <CardSale
                      key={relatedProduct.id}
                      product={relatedProduct}
                      hasSelectedStore={store !== null}
                    />
                  ))}
                </RelatedTrack>
                <RelatedArrow
                  type="button"
                  className="right"
                  aria-label="Próximo"
                  onClick={() => scrollRelated(1)}
                >
                  <FiChevronRight />
                </RelatedArrow>
              </RelatedViewport>
            </RelatedSection>
          )}
        </ContainerProduct>
      </Container >
    </MainLayout>
  );
}
